import type { UseQueryOptions, UseQueryResult } from "react-query"
import { useQuery } from "react-query"
import { useClient } from "../BeeBoxApiClientContext"
import type {
	Measurements,
	MeasurementValue,
	SensorMeasurementsSeriesVariables,
} from "../client"

export function useSensorMeasurementsSeriesQuery<M extends MeasurementValue>(
	variables: SensorMeasurementsSeriesVariables,
	options?: UseQueryOptions<Measurements<M>>,
): UseQueryResult<Measurements<M>> {
	const client = useClient()
	return useQuery<Measurements<M>>(
		["sensorMeasurementsSeries", variables],
		async () => client.device.getSensorMeasurementsSeries(variables),
		options,
	)
}
